export const APP_VERSION = "V1.3.61";

export const RELEASE_SEEN_STORAGE_KEY = `bluesun:release-history-seen:${APP_VERSION}`;

export const RELEASE_HISTORY = [
  {
    version: "V1.3.61",
    date: "2026-11-03",
    title: "询盘列表展示企业背调分层",
    summary: "在商业价值星级旁直接展示 SOP-A/B/C/D/U，快速区分企业证据成熟度与风险状态。",
    changes: [
      "复用列表接口已有的 SOP 分层字段，不增加数据库查询或加载完整背调详情。",
      "SOP 等级紧邻五星显示，并用独立颜色区分证据充分、待核实、确认风险和信息不足。",
      "悬浮说明明确展示等级含义，并强调 SOP 分层不替代现有 47 分五星商业价值。",
      "只调整列表展示，不改变背调算法、自动回复、审核权限或 SMTP 发送门禁。",
    ],
  },
  {
    version: "V1.3.55",
    date: "2026-11-02",
    title: "客户邮件正文可靠加载",
    summary: "修复完整正文异步加载期间被误显示为空，并为加载失败提供明确提示和重试入口。",
    changes: [
      "完整正文随询盘详情立即加载，不再等待浏览器空闲时机。",
      "明确区分正文加载中、加载失败与原始邮件确实为空三种状态。",
      "不完整的详情缓存自动失效，正文接口结果同时回填页面状态和详情缓存。",
      "正文读取失败不再静默忽略，可在当前询盘直接重试，不影响 AI、回复和邮件发送流程。",
    ],
  },
  {
    version: "V1.3.50",
    date: "2026-10-28",
    title: "首封销售引导与富通负责人提示",
    summary: "先回应客户请求，再提出低门槛的下一步问题；询盘队列直接展示富通历史档案负责人。",
    changes: [
      "有效售前首封默认两项简单问题，已知数量、地点和产品不重复询问，售后与含糊留言独立处理。",
      "富通负责人按当前账号凭证范围、客户邮箱精确匹配；多档案和归档情况提示人工核对，不自动转派。",
      "加强共享发件邮箱防重复发送、多语言表单解析、安全称呼和最终签名引用检查。",
      "不改写历史回复、不批量重发，保留广告、跟进邮件与自动发送权限边界。",
    ],
  },
  {
    version: "V1.3.47",
    date: "2026-10-27",
    title: "一屏式业务工作台",
    summary: "首页拆分为默认业务工作台与完整统计报表，在常用桌面尺寸内直接看到核心指标、待办客户、趋势和服务概要。",
    changes: [
      "首页默认展示收件、回复、待审核、失败和高价值指标，并将待处理客户提升为页面主体。",
      "待审核、高价值优先和处理失败客户支持快速切换，客户列表独立滚动并可直接进入询盘详情。",
      "七日趋势、服务配置和 AI 用量改为紧凑概要，完整日期趋势、每日明细和历史对比保留在独立统计报表中。",
      "桌面端按可视高度弹性分配空间，手机、低屏和放大显示采用自然滚动，不裁切关键操作。",
      "30 秒更新支持新增客户无感出现，刷新保持列表位置，并加强日期请求和账号切换的数据隔离。",
    ],
  },
  {
    version: "V1.3.46",
    date: "2026-10-26",
    title: "工作台日期复盘与每日统计",
    summary: "今日工作台支持今天、昨天、本周、上周、近 7 天和自定义日期，清楚区分收件、回复与当前待办。",
    changes: [
      "新增按业务时区统计的日期报表，上周固定为周一至周日，自定义范围最多 93 天。",
      "分别按收件时间和实际发送时间统计询盘与回复，避免把历史询盘的当天回复混入当天收件。",
      "新增每日趋势、逐日明细、高价值询盘、草稿、待审核、失败及 AI 调用数据。",
      "日期报表与全部日期的当前待办分开呈现，历史筛选不会隐藏仍需处理的事项。",
      "页面可见时每 30 秒无感更新，失败保留上次数据，并完成桌面和手机端适配。",
    ],
  },
  {
    version: "V1.3.30",
    date: "2026-10-12",
    title: "背调检索与取证基础修复",
    summary: "修复网页正文漏读，按步骤分配搜索和抓取额度，并区分检索、正文获取与事实核验。",
    changes: [
      "修复搜索框、隐藏图片及嵌套标签导致后续正文全部丢失的问题。",
      "客户官网直接读取优先，关键背调步骤独立分配查询额度，不因前面来源占满而停止。",
      "保留每条查询的实际执行结果，分开显示已搜索、找到来源、取得正文、核验通过。",
      "资料不足、公共邮箱、大项目及跨行业采购仅产生待核实提醒，不直接认定风险客户。",
      "历史背调和已发送回复保留原样，旧查询执行记录缺失时不冒充已完成核验。",
    ],
  },
  {
    version: "V1.3.29",
    date: "2026-10-12",
    title: "WhatsApp 自然接待与业务交接",
    summary: "接入经过整理的沟通话术、产品知识依据与持久消息队列，完成需求采集后的业务跟进。",
    changes: [
      "按客户场景和语言一次追问一个关键问题，已提供的信息不再重复询问。",
      "明确需求需包含产品与容量/数量，或产品与用途和地区，避免过早停止采集。",
      "支持电子名片提取邮箱、公司、职位和官网；客户自述保留待核实标识。",
      "采集完成创建负责人跟进任务，后续补充继续更新任务；人工聊天自动暂停该客户的 AI。",
      "技术回答使用已审核在售产品资料，展示本轮依据，排除未经确认的商务承诺。",
      "连续消息合并为一轮，接收和发送结果持久保存，重启后恢复处理并核对去重。",
    ],
  },
  {
    version: "V1.3.28",
    date: "2026-10-09",
    title: "客户后续来信自动发送边界修复",
    summary: "修复历史引用中的官网表单导致后续邮件误触发自动回复的问题。",
    changes: [
      "优先识别回复主题、客户后续来信分类及历史引用，禁止自动发送后续邮件。",
      "官网表单仅检查本次来信正文，独立提交的新询盘仍可正常自动回复。",
      "客户明确要求停止联系或关闭询盘时停止自动发送，并向业务员显示处理提醒。",
      "自动发送入口增加独立复核，已发送或发送中的邮件不会再次自动投递。",
    ],
  },
  {
    version: "V1.3.27",
    date: "2026-10-07",
    title: "WhatsApp 智能接待可靠性升级",
    summary: "提高明确需求标准，并将 AI 接待改为持久异步处理与渐进式自然追问。",
    changes: [
      "明确需求必须同时包含产品方向和至少一项容量、数量、场景、目的地、周期或项目阶段信息。",
      "WhatsApp 入站消息先可靠落库，再由独立后台 Worker 生成和发送回复，网关不再同步等待 AI。",
      "短时间连续消息自动合并处理，失败任务指数退避重试，服务重启后会恢复未完成任务。",
      "AI 根据缺失信息一次只询问一个主要问题，并跟随客户语言回复、避免重复提问。",
      "会话详情新增需求完整度和仍缺信息提示，转人工依据更清晰。",
    ],
  },
  {
    version: "V1.3.26",
    date: "2026-10-01",
    title: "多语言询盘产品识别修复",
    summary: "修复俄语等本地化官网表单未写入来源产品、导致客户评分偏低的问题。",
    changes: [
      "扩充俄语、西班牙语、法语、葡萄牙语、德语、意大利语和阿拉伯语官网表单字段识别。",
      "评分引擎新增多语言光伏、储能、逆变器和充电产品关键词及常用功率单位识别。",
      "本地化官网表单可正确判定为独立首封询盘，不再依赖英文 Inquiry Product 字段。",
      "新增安全历史修复工具，只恢复来源产品并重算评分，不生成草稿、不发送邮件。",
    ],
  },
  {
    version: "V1.3.25",
    date: "2026-10-01",
    title: "客户分层标识与评分弹窗优化",
    summary: "询盘列表直接显示客户 SOP 分层，并修复背调覆盖状态在评分弹窗中的拥挤与越界。",
    changes: [
      "询盘列表在国家标签后新增 SOP-A/B/C/D/U 分层标识，快速识别客户成熟度。",
      "评分依据弹窗扩大可用宽度，六步背调状态改为卡片内部两行布局。",
      "较长的核验状态和步骤名称支持安全换行，不再遮挡相邻卡片或被截断。",
      "窄屏继续使用单列核验卡片，保持信息完整且避免横向滚动。",
    ],
  },
  {
    version: "V1.3.24",
    date: "2026-10-01",
    title: "WhatsApp 账号归属与完整权限",
    summary: "由实际发起绑定的系统用户负责 WhatsApp，账号负责人和管理员拥有完整管理权限。",
    changes: [
      "未绑定账号时必须先点击由我添加，再显示二维码，系统据此记录真实添加人。",
      "账号负责人和管理员均可开启或关闭 AI、修改采集规则并操作客户会话。",
      "新增 WhatsApp 退出账号功能；退出后立即停止接待并释放负责人归属。",
      "二维码和退出接口增加后端权限校验，其他普通用户保持只读且无法取得绑定二维码。",
    ],
  },
  {
    version: "V1.3.23",
    date: "2026-10-01",
    title: "WhatsApp 关联自愈与负责人权限",
    summary: "修复失效二维码残留，并允许已绑定 WhatsApp 的负责人直接管理 AI 自动接待。",
    changes: [
      "WhatsApp 关联被拒绝或会话登出后立即撤下旧二维码，网关自动重启并生成全新二维码。",
      "新增二维码生成时间、版本号和关联状态日志，避免继续扫描已失效的二维码。",
      "WhatsApp 配置权限由仅管理员调整为管理员或账号负责人均可管理。",
      "已连接但未指定负责人的账号可由当前用户认领，其他普通用户仍保持只读。",
    ],
  },
  {
    version: "V1.3.22",
    date: "2026-09-30",
    title: "WhatsApp 智能接待第一阶段",
    summary: "新增独立 WhatsApp 接待工作台，完成账号绑定、AI 信息采集、确定性停止与人工接管闭环。",
    changes: [
      "导航栏新增 WhatsApp 接待，可查看已绑定账号、连接状态、扫码二维码与网关异常。",
      "复用自动询盘的 AI 模型，自动提取客户邮箱、产品方向和需求摘要，并保留完整会话记录。",
      "获取邮箱和明确需求后自动停止该会话回复；停止状态持久化，服务重启后仍然有效。",
      "新增最大沟通轮次、首次引导语和完成确认语配置，并支持人工接管、恢复 AI 接待和手动完成。",
    ],
  },
  {
    version: "V1.3.21",
    date: "2026-09-30",
    title: "官网重复询盘首封识别修复",
    summary: "修复同一客户再次通过官网表单提交相同产品时被误判为后续邮件的问题。",
    changes: [
      "完整识别 Inquiry Product、Name、Email、Message、IP Address 等官网表单字段。",
      "官网每次独立提交均按新的首封询盘处理，即使客户和产品主题与历史记录相同。",
      "普通邮件的 Re/Fwd、历史引用和客户后续来信分类仍不会触发自动发送。",
      "产品事实不足等知识提醒继续保留在页面，但不会阻断已开启的首封自动回复。",
    ],
  },
  {
    version: "V1.3.20",
    date: "2026-09-30",
    title: "评分依据透明化与首封自动回复边界",
    summary: "评分页同时展示完整计分规则和本次询盘证据；自动发送严格限定为客户首封询盘。",
    changes: [
      "新增五星分数区间总览，并逐项说明 47 分规则中每一个可获得的分值条件。",
      "每个评分维度新增本次询盘具体依据，展示采用的产品、身份、邮箱、电话和原文命中内容。",
      "自动回复新增后端确定性首封校验，综合识别回复主题、历史引用、AI 分类和同主题更早来信。",
      "客户后续来信仍会生成翻译、背调和回复草稿，但不会自动发送，并在回复区保留明确提醒。",
    ],
  },
  {
    version: "V1.3.19",
    date: "2026-09-28",
    title: "客户背调 SOP 兼容层上线",
    summary: "在现有五星商业价值和身份核验基础上，补充 SOP 分层、研究优先级与六步核验进度。",
    changes: [
      "新增 SOP-A/B/C/D/U 映射；它用于解释客户成熟度，不替代现有 47 分五星评级。",
      "新增 P0～P3 背调优先级，高价值项目优先获取完整证据，但不改变客户星级。",
      "评分依据页新增六步背调覆盖进度，明确区分已取得证据、未检索到证据、异常和待执行。",
      "扩充企业注册、B2B、联系人和海关贸易来源注册表；付费或登录来源只标记为人工参考。",
      "SOP 与研究结果只产生展示和提醒，不作为自动回复或自动发送的拦截条件。",
    ],
  },
  {
    version: "V1.3.18",
    date: "2026-09-28",
    title: "五星评级身份核验最终收口",
    summary: "修复持续集成、无姓名联系方式核验和企业域名边界，并补齐公司名称的数据链路。",
    changes: [
      "前后端测试拆分运行，并修复 pnpm 9 工作区安装失败，避免单侧故障跳过另一侧测试。",
      "即使客户未填写姓名，只要存在邮箱或电话，仍会进入联系人公开证据核验。",
      "企业官网域名匹配不再被当作联系人身份闭环，评分依据会明确显示企业域名与联系人证据的差别。",
      "新增 Company、Organization、公司名称等结构化字段解析，并同步写入询盘和客户档案；历史空字段可安全回填。",
      "域名、注册与制裁风险明确标注为基于已抓取公开证据，不虚构实时 DNS、WHOIS 或名单接口结论。",
    ],
  },
  {
    version: "V1.3.17",
    date: "2026-09-28",
    title: "评级迁移与备份安全收口",
    summary: "完成生产历史评级迁移，并修复每日备份保留规则，恢复服务器安全容量。",
    changes: [
      "生产历史询盘统一迁移到 bluesun_47_v2，回填过程不生成回复、不发送邮件。",
      "修复历史评级回填读取研究状态的兼容问题，全部项目组已成功完成重算。",
      "修复每日备份日期匹配错误，恢复只保留最近7份完整备份的既定策略。",
      "补跑数据库、业务数据、对象存储和系统配置全量备份，并通过全部校验和验证。",
    ],
  },
  {
    version: "V1.3.16",
    date: "2026-09-28",
    title: "五星评级核验闭环与规则收口",
    summary: "修正规则边界，补齐邮箱和电话核验状态、结构化风险，并拆分当前项目优先级与历史最高项目。",
    changes: [
      "修正30kW/kWh/kVA边界、无效产品文本、纯数字身份和新能源域名关键词等确定性评分细节。",
      "邮箱与电话核验新增待核验、已匹配、未匹配和核验异常状态；只有明确公开证据才认定匹配。",
      "高可信改为依据独立来源、硬证据、身份闭环和业务匹配计算，并补充跨行业、域名、注册与敏感询价风险。",
      "客户档案分别展示当前项目优先级与历史最高项目，人工改星不再影响同邮箱的其他独立项目。",
      "修复干净环境首次邮箱同步和前端静态资源测试流程，历史回填统一使用新版47分引擎。",
    ],
  },
  {
    version: "V1.3.15",
    date: "2026-09-27",
    title: "五星评级可解释化升级",
    summary: "五星评级升级为47分确定性规则，并将系统评分、身份核验、风险和人工调整分开管理。",
    changes: [
      "产品、姓名、邮箱、电话和邮件需求按固定47分规则计算，同一客户的项目往来合并重算。",
      "AI背调不再自行决定星级，只解释系统评分、公开证据、风险与待核实事项。",
      "询盘详情新增评分依据，可查看五项得分、身份核验、报价保护和最近评分记录。",
      "人工调整必须填写原因，系统评分继续保留并可一键恢复；核验等待或失败不阻断自动回复。",
    ],
  },
  {
    version: "V1.3.14",
    date: "2026-09-25",
    title: "广告阈值与自动回复直通",
    summary: "广告识别并入翻译流程，只有达到可配置阈值才停止处理，低于阈值的有效邮件继续自动回复。",
    changes: [
      "设置页新增广告拦截置信度，默认 90%，管理员可在 0% 至 100% 范围内调整。",
      "翻译阶段同步判断邮件意图；明确采购、报价、项目合作和客户跟进优先进入正常询盘流程。",
      "广告置信度达到阈值时标记为广告邮件，并跳过翻译展示、背调、回复生成和发送，原邮件仍完整保留。",
      "广告置信度低于阈值时不再进入人工确认；自动回复开启后直接完成生成与发送，风险提示仅在页面留存。",
    ],
  },
  {
    version: "V1.3.13",
    date: "2026-09-24",
    title: "知识冲突非阻断闭环",
    summary: "产品事实冲突自动归并为待审核规则，未审核规则不参与生成，也不会影响自动回复。",
    changes: [
      "知识中心新增冲突规则页，集中展示产品依据不足和跨产品参数拼接问题。",
      "同类冲突自动去重并累计触发次数，管理员可审核启用或停用建议规则。",
      "只有管理员审核启用的规则才会进入后续 AI 回复生成，待审核规则保持零运行时影响。",
      "冲突记录采用失败隔离设计，即使治理模块异常也不会暂停或延迟有效询盘的自动发送。",
    ],
  },
  {
    version: "V1.3.12",
    date: "2026-09-24",
    title: "自动回复全量发送与风险提醒留存",
    summary: "关闭发布前审核后，所有有效客户询盘都会自动发送，安全校验改为页面提醒而不再拦截。",
    changes: [
      "自动回复流程关闭人工审核后，产品依据不足、事实组合风险和商务结构提醒不再阻止真实发送。",
      "自动发送成功后继续保留风险提醒，业务员可在询盘详情中查看具体核对事项。",
      "退信、系统回执、对方自动回复和营销群发继续识别为无需回复，避免错误循环发信。",
      "增加自动发送带提醒场景的回归测试，并明确设置页中两种发布模式的实际行为。",
    ],
  },
  {
    version: "V1.3.11",
    date: "2026-09-17",
    title: "客户回复邮件格式与图片兼容",
    summary: "系统回复保留完整原始询盘格式与商品图片，签名和可信图片改为邮件内嵌显示。",
    changes: [
      "HTML 回复直接引用经过安全过滤的完整原始邮件，不再把客户询盘降级成简短纯文本。",
      "完整保留产品图片、客户表单字段和原始排版，纯文本邮箱也可读取完整备用内容。",
      "BLUESUN 官网商品图和签名图通过 CID 内嵌发送，减少外部图片被邮箱拦截或尺寸异常。",
      "修复邮件主题中的 &amp; 等 HTML 实体，并增加 MIME 图片及完整原文回归测试。",
    ],
  },
  {
    version: "V1.3.10",
    date: "2026-09-09",
    title: "询盘原始邮件统一完整展示",
    summary: "询盘工作台的客户邮件区域直接显示该封邮件的完整原始内容，方便业务员核对全部历史引用。",
    changes: [
      "所有询盘统一优先显示完整原始 HTML 邮件，保留客户邮件中的历史往来与原始排版。",
      "没有 HTML 正文时优先显示完整原始纯文本，不再先使用供 AI 处理的清洗正文。",
      "原始 HTML 继续经过安全过滤；AI 翻译、背调、回复和已生成数据保持原有逻辑不变。",
    ],
  },
  {
    version: "V1.3.9",
    date: "2026-09-09",
    title: "客户邮件往来完整还原",
    summary: "历史邮件不再依赖最新邮件中的嵌套引用，按每次独立收件与已发送回复还原完整往来。",
    changes: [
      "同一客户的每封来信和已发送回复按时间独立展示，避免旧引用被截断后继续传播。",
      "修复 Gabriel 首封询盘历史显示不完整的问题，保留完整需求、电话及询价条件。",
      "识别葡萄牙语等多语言回复分隔语，当前客户正文不会混入上一轮邮件和签名。",
      "发送回复时从完整原文重新提取客户正文，即使旧清洗字段不完整，也不会再次引用截断内容。",
    ],
  },
  {
    version: "V1.3.8",
    date: "2026-09-08",
    title: "完整邮件线程与 AI 正文分离",
    summary: "客户原文完整保留全部历史往来，AI 继续使用独立清洗后的有效客户内容。",
    changes: [
      "客户原文编辑器优先读取邮箱完整正文，不再被最新一段清洗文本提前截断。",
      "完整邮件线程与 AI 有效正文分字段存储，历史签名和内部回复不会污染 AI 分析。",
      "询盘正文按需加载接口同时返回完整纯文本，HTML 不可用时仍可完整展示历史邮件。",
      "客户原文保存上限由 50,000 字符提高至 250,000 字符。",
    ],
  },
  {
    version: "V1.3.7",
    date: "2026-09-02",
    title: "邮件后台任务断线自恢复",
    summary: "数据库或 Redis 因系统维护短暂重启时，邮件发送和后台处理线程会持续重试，不再静默退出。",
    changes: [
      "修复服务器自动安全更新重启 PostgreSQL 后，邮件发送任务只入队但后台线程停止消费的问题。",
      "邮件发送、AI 处理、邮件正文加载和行业情报任务增加存储断线重试保护。",
      "应用恢复后继续处理已明确提交的发送任务，结果不确定的中断邮件仍保留人工核对，避免重复发送。",
      "邮箱连接测试与发送队列分开监控，便于快速区分邮箱认证故障和后台任务故障。",
    ],
  },
  {
    version: "V1.3.6",
    date: "2026-08-31",
    title: "AI 回复转人工审核提醒",
    summary: "内容质量问题不再把询盘标记为处理失败，草稿会完整保留并提示业务员审核后发布。",
    changes: [
      "产品依据不足、商务结构不完整或措辞风险改为发送前提醒，不再拒绝生成和保存 AI 草稿。",
      "AI 服务异常经过后台重试后转为待审核提醒，询盘仍可人工编辑、重新生成或继续处理。",
      "个人设置新增“自动回复发布前需审核”开关并默认开启，自动流程不会未经确认直接发信。",
      "回复编辑器展示具体审核事项，业务员点击确认审核后即可提交后台发送。",
      "邮件已提交后仍由后台无感发送；真实 SMTP 发送异常继续如实提示，避免误报已送达。",
    ],
  },
  {
    version: "V1.3.5",
    date: "2026-08-29",
    title: "询盘工作台首屏与详情提速",
    summary: "列表与首条核心详情合并加载，点击询盘立即展示客户信息，背调依据和客户历史按需读取。",
    changes: [
      "首次进入询盘工作台由一次核心请求同时返回列表和最新询盘详情，消除列表完成后再请求详情的串行等待。",
      "点击询盘后立即切换客户名称、国家、产品、状态和星级，正文区域使用局部骨架屏等待核心数据。",
      "紧凑详情不再同步查询背调来源和回复知识依据，相关内容只在打开 AI 分析或回复页面时加载。",
      "客户历史读取改为纯查询，不再因浏览详情触发客户档案写入或重复聚合。",
      "AI 处理以实时事件为主，连接持续失败后才启用低频兜底轮询，减少重复详情与列表请求。",
      "新增 Server-Timing、SQL 数量和浏览器性能标记，便于区分数据库、后端序列化与公网链路耗时。",
    ],
  },
  {
    version: "V1.3.4",
    date: "2026-08-29",
    title: "产品事实组合安全边界收口",
    summary: "AI 回复中的型号、容量、功率、认证、IP、质保和兼容性必须由同一组已审核产品证据共同支持。",
    changes: [
      "产品知识按来源、型号和知识片段建立可追溯 Fact Group，禁止把不同产品的参数拼接成不存在的配置。",
      "回复按句提取 Product Claim Group，并使用型号、容量、功率和产品类别锁定对应产品证据。",
      "新增 has、meets、complies、carries、offers、works with、equipped with 等商务承诺表达校验。",
      "缺少明确 Research Task Metadata 的历史来源继续展示，但不再生成客户结论、置信度或冲突。",
      "行业目录出现多个国家时只接受明确的 Country、Location、Headquarters、Registered、Based 或 Address 字段。",
      "不受支持的产品事实组合同时阻止自动发送与人工发送，并记录不含客户原文的安全日志。",
    ],
  },
  {
    version: "V1.3.3",
    date: "2026-08-28",
    title: "海外背调来源分类筛选修复",
    summary: "修复海外背调来源注册表选择来源分类后列表返回服务器错误的问题。",
    changes: [
      "修正来源注册表与背调使用记录关联查询中的同名字段歧义。",
      "行业媒体、市场数据、行业目录等来源分类现在可以正常筛选和展示。",
      "搜索、启用状态和来源分类条件统一使用明确的数据表范围，避免后续扩展再次触发相同错误。",
      "新增来源分类筛选回归测试，确保完整列表与分类列表同时可用。",
    ],
  },
  {
    version: "V1.3.2",
    date: "2026-08-28",
    title: "客户证据语义收口与产品事实通用校验",
    summary: "公开来源必须同时符合检索任务、客户实体和语义范围才能形成客户结论，AI 回复的产品事实校验扩展到主要技术与商务声明。",
    changes: [
      "市场与价格类资料继续作为内部销售背景，但不再生成客户公司、联系人、项目容量或项目国家结论。",
      "公司国家、官网域名、联系人职位和客户项目改为局部实体关联，减少整页文本扫描造成的错误冲突。",
      "项目容量与国家优先匹配客户公司和当前项目窗口，同一公司的其他项目或市场规模不会污染本次询盘。",
      "背调置信度和冲突只使用相同实体、相同任务及相同证据范围内的 Customer Claim。",
      "AI 回复事实校验覆盖功率、容量、认证、IP 等级、质保、兼容性和精确型号，并支持 W/kW、kWh/MWh 等单位归一化。",
      "待确认、待评估和兼容性核对等谨慎表述保持允许，不会因客户提出某个参数而被过度拦截。",
    ],
  },
  {
    version: "V1.3.1",
    date: "2026-08-28",
    title: "背调证据交叉核验与行业检索升级",
    summary: "置信度改为基于结构化事实与独立来源计算，行业情报优先使用来源注册表，并保留开放发现能力。",
    changes: [
      "只有多个独立来源支持同一项事实才会标记为已交叉验证；相互冲突的公司、国家、项目容量等信息会直接提示人工复核。",
      "证据不足时不再显示默认 35%，改为明确显示证据不足，并列出支持来源和冲突来源。",
      "行业同步采用约 80% 注册来源定向检索与 20% 开放发现，查询年份随系统年份自动更新。",
      "行业情报新增市场、技术、公司和标签提取，可按市场与技术筛选，并区分注册来源和开放发现。",
      "关键词、向量和重排继续混合检索，但权威度与新鲜度仅作为小幅加分；过期内容不会从任一路径召回。",
      "后台同步任务增加实例租约与续租，避免多实例启动时重复执行仍在运行的任务。",
      "AI 回复新增具体产品功率事实校验：竞品或行业资料中的型号不能越界成为 BLUESUN 供货承诺。",
    ],
  },
  {
    version: "V1.3.0",
    date: "2026-08-28",
    title: "企业知识中心与智能 Research Planner",
    summary: "知识库升级为产品事实、行业情报和海外背调来源三域治理，AI 背调开始按客户信号规划检索并展示置信度。",
    changes: [
      "产品事实库与外部行业信息严格隔离，外部网页不会自动成为 BLUESUN 产品参数或销售承诺。",
      "新增行业情报库，支持公开来源采集、URL 去重、时效控制、内容切片、混合检索和后台任务重试。",
      "新增海外背调来源注册表，管理员可治理来源类别、可信等级、查询优先级、访问方式和交叉验证规则。",
      "AI 背调根据企业域名、联系人、项目规模和客户星级自动选择标准或深度检索计划。",
      "询盘背调页面新增身份、业务、项目、联系方式与综合置信度，并展示检索任务和交叉验证状态。",
      "普通业务员可查看三类知识和本人背调使用记录；来源配置、同步和启停仍由管理员控制。",
    ],
  },
  {
    version: "V1.2.27",
    date: "2026-08-26",
    title: "产品知识生命周期治理",
    summary: "最新在售资料成为默认产品依据，历史型号和行业资料保留查询价值但不再混入普通 AI 推荐。",
    changes: [
      "新增当前在售、特殊需求、历史型号、已被替代、停止推荐和非产品资料等生命周期状态。",
      "2026-08-25 在售产品 PDF 获得最高检索优先级；旧版 bluesun-products 转为历史与特殊需求知识空间。",
      "客户明确提供旧型号时仍可受控召回历史资料，但回复必须提示供货或替代方案需要确认。",
      "行业知识作为研究导航独立入库，不再作为 BLUESUN 产品参数、库存或销售承诺依据。",
      "知识库页面可按生命周期筛选，并显示资料生效日期、权威值及是否允许参与 AI 回复。",
      "导入过程自动识别重复资料，优先保留高权威来源，避免重复内容放大检索权重。",
    ],
  },
  {
    version: "V1.2.26",
    date: "2026-08-26",
    title: "询盘列表无感更新",
    summary: "业务员停留在询盘工作台时持续获取最新询盘和处理状态，不再依赖手动刷新或重新进入页面。",
    changes: [
      "询盘工作台处于前台时每 20 秒静默读取最新列表，新增邮件会自动出现在当前视图。",
      "浏览器重新获得焦点、标签页恢复可见或网络恢复时自动补充刷新。",
      "后台刷新保留当前询盘、筛选条件、滚动位置、批量选择和正在编辑的回复正文。",
      "静默请求不显示骨架屏或整页加载，失败时保留现有数据并等待下一次自动恢复。",
      "新增请求顺序保护与节流，避免慢请求覆盖最新结果或焦点事件造成重复请求。",
    ],
  },
  {
    version: "V1.2.25",
    date: "2026-08-25",
    title: "导航切换无感提速",
    summary: "减少不同功能页面之间反复切换时的大面积加载提示，已访问页面会保留数据与操作位置。",
    changes: [
      "页面首次打开后在当前登录会话中保活，返回询盘、邮件、知识库或设置时不再重复卸载和请求。",
      "鼠标移入、键盘聚焦或按下导航项时提前启动目标页面数据加载，缩短首次进入的等待感。",
      "隐藏页面暂停询盘处理轮询、事件流和邮件正文轮询，避免保活后产生无意义的后台请求。",
      "页面保留筛选条件、选中记录、滚动上下文和未保存表单，导航切换不再清空工作进度。",
    ],
  },
  {
    version: "V1.2.24",
    date: "2026-08-25",
    title: "客户电话提取修复",
    summary: "修复客户在原文中留下电话或 WhatsApp 号码但询盘字段为空的问题，并保护引用邮件中的员工号码。",
    changes: [
      "新增 Tel/WhatsApp、Mobile、Cell、Telephone 以及西语、俄语、阿拉伯语等常见电话标签识别。",
      "支持官网表单同一行包含多个字段，以及客户在自然语句中主动留下 WhatsApp 号码的情况。",
      "提取前自动清理不可见字符并截断历史引用，避免把 BLUESUN 员工签名号码识别为客户号码。",
      "新增历史空字段安全回填工具，只写入高置信度号码并同步客户档案。",
    ],
  },
  {
    version: "V1.2.23",
    date: "2026-08-24",
    title: "登录首页响应式适配",
    summary: "登录与注册首页改为按实际屏幕高度和宽度自适应，消除小屏裁切并让移动端优先看到账号入口。",
    changes: [
      "桌面首屏由固定 900px 改为跟随浏览器可视高度，常见笔记本分辨率不再裁切登录卡片。",
      "针对低高度笔记本压缩首屏留白与表单间距，同时保留完整的登录操作区域。",
      "平板和手机端将登录卡片提前到首屏，并统一窄屏边距与卡片宽度。",
      "完成桌面、笔记本、平板和手机五种视口的溢出与首屏布局回归。",
    ],
  },
  {
    version: "V1.2.22",
    date: "2026-08-24",
    title: "知识空间与调用关系",
    summary: "产品知识库升级为可追溯的知识运营工作台，可查看知识分类、内容片段、索引状态和实际引用询盘。",
    changes: [
      "按储能、逆变器、光伏组件等产品分类建立知识空间目录，来源不再以单一长列表平铺。",
      "新增知识来源、内容分段、混合检索到回复引用的真实调用关系，统计来自数据库证据记录。",
      "点击知识来源可查看清洗后的知识片段、审核状态、向量索引状态及产品型号信息。",
      "新增最近调用记录，管理员可查看引用该知识的询盘，业务员仅查看本人可访问的引用记录。",
    ],
  },
  {
    version: "V1.2.21",
    date: "2026-08-22",
    title: "AI 回复事实边界强化",
    summary: "完善首封商务回复规则，并对兼容性、库存、组件替代、企业数据、质保和认证建立更严格的事实边界。",
    changes: [
      "首封回复禁止自动输出具体价格，客户未提出时不主动引入 OEM 或贴牌合作。",
      "第三方逆变器兼容性改为按具体型号、电压、BMS 通讯协议和电气配置确认，禁止绝对兼容表述。",
      "欧洲仓储地点与实时库存分离，没有当前库存证据时不承诺现货或立即发运。",
      "组件替代建议需综合尺寸、认证、运输、安装限制和市场供应，不再机械推荐固定功率。",
      "企业数据、质保、循环寿命与认证必须来自已审核知识并对应具体型号；UN38.3按运输测试准确表述。",
    ],
  },
  {
    version: "V1.2.20",
    date: "2026-08-22",
    title: "内部产品知识直接生效",
    summary: "修正管理员批量上传资料仍进入待审核的问题，受控产品目录导入后可直接用于 AI 回复。",
    changes: [
      "管理员在服务器通过受控发布脚本上传的产品资料会直接标记为已审核，并补齐向量索引。",
      "现有批量上传但处于待审核的内部资料可幂等重新导入，无需逐条点击审核。",
      "业务员从网页新增或修改的资料仍需管理员审核，继续保持知识安全边界。",
      "导入结果新增审核模式标识，便于系统日志区分管理员受控导入与普通资料提交。",
    ],
  },
  {
    version: "V1.2.19",
    date: "2026-08-22",
    title: "产品知识 Hybrid RAG",
    summary: "产品知识检索升级为全文、语义向量与重排融合，并保持审核边界和故障降级能力。",
    changes: [
      "新增 PostgreSQL FTS 与 BAAI/bge-m3 语义召回，精确型号、功率、容量和电压参数获得额外权重。",
      "关键词和向量候选通过 RRF 融合，再由 BAAI/bge-reranker-v2-m3 重排，提高复杂场景知识命中率。",
      "Embedding 或 Reranker 服务异常时自动退回全文或关键词检索，不会阻断 AI 回复生成。",
      "产品知识库新增向量索引状态、待补齐数量和后台重建入口；AI 回复依据保留各阶段检索分数。",
    ],
  },
  {
    version: "V1.2.18",
    date: "2026-08-22",
    title: "产品资料批量知识化",
    summary: "BLUESUN 产品 Markdown 与 PDF 资料按审核状态批量进入知识库，并保留原始来源与审核边界。",
    changes: [
      "产品知识目录按储能、逆变器、光伏组件、光伏系统和配套产品统一整理并生成目录索引。",
      "已审核资料和内部产品画册进入 AI 检索；草稿与未标注资料只上传为待审核，不会直接影响英文回复。",
      "批量导入支持重复执行和增量更新，同一资料不会反复新增重复知识来源。",
      "知识库页面区分官网来源与 BLUESUN 内部资料，AI 回复依据也会明确标注内部已审核资料。",
    ],
  },
  {
    version: "V1.2.17",
    date: "2026-08-22",
    title: "AI 回复依据可追溯",
    summary: "英文回复正文下方新增知识库引用依据，帮助业务员核对产品事实与官方来源。",
    changes: [
      "AI 回复草稿下方新增“查看 AI 回复依据”，展示实际采用的已审核知识条目。",
      "每条依据显示回复匹配点、知识摘要、产品分类及 BLUESUN 官方来源链接。",
      "候选知识与实际引用分离，未在最终回复中体现的资料不会标记为回复依据。",
      "按意见重新生成回复后会同步重算引用依据，未引用知识库时给出明确提示。",
    ],
  },
  {
    version: "V1.2.16",
    date: "2026-08-22",
    title: "富通接口个人配置",
    summary: "富通 OpenAPI 地址与 SecretKey 纳入个人设置，并为现有账号安全补齐当前凭证。",
    changes: [
      "个人设置新增“外部系统”，每位用户可独立管理富通服务地址与 SecretKey。",
      "SecretKey 使用服务器密钥加密保存，浏览器和设置接口只显示是否已配置，不返回明文。",
      "富通查询优先使用当前登录用户的配置，同时保留部署环境凭证作为初始化兼容来源。",
      "现有注册用户在升级时自动补齐当前富通凭证，已有个人配置不会被覆盖。",
    ],
  },
  {
    version: "V1.2.15",
    date: "2026-08-21",
    title: "富通客户按负责人查询",
    summary: "富通客户页支持填写负责人，并读取该负责人最近更新的 10 条完整客户记录。",
    changes: [
      "负责人条件直接提交给富通 OpenAPI 筛选，避免只在当前十条结果中进行不完整过滤。",
      "查询结果继续按更新时间倒序排列，并保留富通接口返回的全部动态字段。",
      "增加负责人必填校验、回车查询、当前查询负责人提示及移动端布局适配。",
    ],
  },
  {
    version: "V1.2.14",
    date: "2026-08-21",
    title: "邮件无感后台发送",
    summary: "审核回复提交后无需等待 SMTP，系统通过持久化任务在后台可靠发送。",
    changes: [
      "确认发送后立即关闭弹窗并提示已提交，业务员可以继续处理其他询盘。",
      "新增等待发送、邮件发送中、已回复和发送失败状态，页面会自动刷新结果。",
      "发送任务写入数据库后再返回，刷新页面或关闭浏览器不会中断邮件发送。",
      "加入重复提交保护；服务在发送途中重启时不会盲目重发，避免客户收到重复邮件。",
    ],
  },
  {
    version: "V1.2.13",
    date: "2026-08-20",
    title: "二次生成草稿发送修复",
    summary: "修复业务员按修改意见重新生成回复后，新草稿无法保存和发送的问题。",
    changes: [
      "补齐生产 PostgreSQL 中回复计划字段，现有数据库会在服务启动时自动、安全迁移。",
      "按意见重新生成会正确保存为最新待审核草稿，审核发送使用当前编辑器中的新正文与收件人。",
      "新增“首次生成、按意见二次生成、审核发送”完整回归测试，且测试不会向真实联系人发送邮件。",
      "补充 PostgreSQL 结构契约测试，防止开发环境与生产数据库字段再次不一致。",
    ],
  },
  {
    version: "V1.2.12",
    date: "2026-08-20",
    title: "客户意图路由与连续对话回复",
    summary: "AI 回复在写作前先形成可审计的回复计划，并结合已发送历史邮件延续真实业务对话。",
    changes: [
      "新增客户询盘、报价请求、EPC 项目、经销合作、客户追问、人工复核和非业务邮件的确定性分类。",
      "每封询盘持久化回复等级、问题数量、目标篇幅、企业背书和下一步推进策略，便于排错与复核。",
      "后续来信会读取同一客户最近往来，只引用已经实际发送的 BLUESUN 回复，不把未发送草稿当作沟通事实。",
      "高价值 EPC 与经销首封允许询问官网、预计销量、项目储备或经销范围，普通询盘仍保持低门槛问题。",
      "内容过短或无法判断的邮件禁止自动发送并转人工复核，回执、退信和群发邮件标记为“无需回复”并退出待审核队列。",
    ],
  },
  {
    version: "V1.2.11",
    date: "2026-08-20",
    title: "分级商务回复与线索质量校验",
    summary: "AI 回复按商业价值分级生成，并强化明确下一步、合作收尾及非询盘邮件拦截。",
    changes: [
      "1-2 星、3 星和 4-5 星客户分别采用不同的正文长度、问题数量、企业背书和推进动作。",
      "回复固定形成称呼、Good day、直接回应、低门槛问题、明确交付动作和场景化合作收尾的完整闭环。",
      "客户同时提供有效电话和含关键参数的明确需求时，作为可解释的商业价值加分项，但不会直接判为五星。",
      "发送前新增称呼、英文正文、下一步、合作收尾、企业口吻、HTML 及非询盘来源校验。",
      "新闻订阅、群发、退信、回执和自动回复在进入 AI 队列前即被拦截，减少无效处理和误回复风险。",
    ],
  },
  {
    version: "V1.2.10",
    date: "2026-08-19",
    title: "询盘工作台默认选中修复",
    summary: "进入询盘工作台后自动打开当前列表最新询盘，并安全处理失效的历史跳转记录。",
    changes: [
      "首次进入询盘工作台自动选择当前排序下的第一封最新询盘，无需再次手动点击。",
      "今日工作台和历史询盘仍可一次性跳转到指定询盘，完成跳转后不再长期保留旧编号。",
      "浏览器残留的询盘编号失效时自动回退到最新询盘，不再显示“询盘不存在”。",
      "筛选或翻页后若原选中项已不在当前列表，会同步选择当前页第一封询盘。",
    ],
  },
  {
    version: "V1.2.9",
    date: "2026-08-19",
    title: "多账号定时同步容错修复",
    summary: "自动同步继续按所有已启用账号独立运行，并避免异常邮件阻断整个账号。",
    changes: [
      "确认后台定时同步与当前登录用户无关，会独立扫描所有已启用自动同步且凭证完整的账号。",
      "兼容邮件网关产生的 unicode 等非标准字符集声明，正文可继续安全解码。",
      "单封格式异常的邮件会被记录并跳过，不再阻断同一账号后续邮件或其他账号同步。",
      "补充询盘与邮件中心的异常字符集回归测试。",
    ],
  },
  {
    version: "V1.2.8",
    date: "2026-08-18",
    title: "询盘正文渐进加载",
    summary: "先展示客户与邮件文字，再异步补齐大体积邮件排版和图片，避免整页被图片阻塞。",
    changes: [
      "点击列表后立即展示所选客户与主题，轻量详情返回后即可查看正文和 AI 结果。",
      "客户历史在详情完成后独立加载，不再阻塞邮件正文展示。",
      "HTML 排版和内嵌图片延迟 350 毫秒按需补齐，切换较快时会取消尚未开始的读取。",
      "撤回会等待全部数据才渲染的 V1.2.7 合并请求方案，避免真实大邮件加载变慢。",
    ],
  },
  {
    version: "V1.2.6",
    date: "2026-08-18",
    title: "今日工作台访问提速",
    summary: "移除首页接口中未展示的邮件全文和 AI 大字段，显著降低等待与传输体积。",
    changes: [
      "工作台待办列表仅返回客户、国家、产品、状态、星级和时间等实际展示字段。",
      "邮件原文、HTML、附件、背调全文和回复草稿继续由询盘详情接口按需读取。",
      "工作台汇总增加 10 秒服务端短时缓存，减少重复刷新和多标签页并发查询。",
      "保留高价值客户、失败任务、系统状态和 AI 用量等原有功能与数据口径。",
    ],
  },
  {
    version: "V1.2.5",
    date: "2026-08-18",
    title: "富通客户独立数据页",
    summary: "富通客户查询升级为一级导航，并完整展示接口返回的全部客户字段。",
    changes: [
      "业务导航新增富通客户入口，不再将查询隐藏在今日工作台的小按钮中。",
      "查询结果根据富通实际响应动态生成全部字段列，嵌套联系人和业务信息也完整展开。",
      "数据表支持固定表头、固定首列和横向滚动，兼顾宽表阅读与移动端查看。",
      "仍保持点击后才调用、用户限流、全局互斥锁和服务端密钥保护。",
    ],
  },
  {
    version: "V1.2.4",
    date: "2026-08-17",
    title: "富通最新客户只读查询",
    summary: "业务员可从今日工作台按需读取富通最近更新的十条客户记录。",
    changes: [
      "今日工作台新增富通最新客户入口，点击后才发起查询，避免后台自动消耗接口额度。",
      "最近十条记录按富通更新时间倒序展示客户、地区、负责人、联系人和业务信息。",
      "富通密钥继续仅保存在服务端，接口增加用户级频率限制、全局互斥锁与审计日志。",
      "查询弹窗补齐加载、空数据、失败重试和移动端响应式状态。",
    ],
  },
  {
    version: "V1.2.3",
    date: "2026-08-12",
    title: "导航结构与自动询盘运行检查",
    summary: "优化侧边导航的品牌区和折叠操作位置，并完成线上自动同步与 AI 队列健康检查。",
    changes: [
      "侧边栏第一行仅展示 BLUESUN 品牌 Logo 与系统名称，减少操作干扰。",
      "桌面端导航折叠按钮固定到底部工具区，展开与折叠状态保持同一操作位置。",
      "折叠状态继续展示 BLUESUN 官网 Logo，导航图标与操作入口保持清晰。",
      "确认线上邮箱定时同步、询盘入库与后台 AI 自动处理队列持续运行。",
    ],
  },
  {
    version: "V1.2.2",
    date: "2026-08-09",
    title: "优质客户标准与星级筛选",
    summary: "让业务团队使用统一标准判断客户价值，并快速定位目标询盘。",
    changes: [
      "个人设置新增优质客户最低星级和一到五星判定标准。",
      "AI 客户背调会参考当前账号保存的星级标准，证据不足时保持未评估。",
      "询盘队列新增优质客户、单个星级和未评估筛选，分页统计与结果保持一致。",
      "今日工作台的优质客户范围同步使用用户设置的最低星级。",
    ],
  },
  {
    version: "V1.2.1",
    date: "2026-08-04",
    title: "产品知识库开放协作",
    summary: "业务员和管理员可以共同维护 AI 回复所使用的产品事实。",
    changes: [
      "普通业务员可查看产品知识库，并提交 BLUESUN 官网资料。",
      "业务员可修改自己提交的资料，修改后自动重新进入待审核状态。",
      "管理员可查看提交人、同步资料、审核通过或停用知识来源。",
      "未成功生成知识片段的资料不能通过审核，避免空内容进入 AI 回复。",
    ],
  },
  {
    version: "V1.2.1",
    date: "2026-08-03",
    title: "企业产品知识层上线",
    summary: "AI 回复开始优先引用可追溯、已审核的 BLUESUN 官方产品信息。",
    changes: [
      "新增 BLUESUN 官方产品知识库与来源证据。",
      "产品资料经过同步、分段和审核后才会用于 AI 回复。",
      "知识库操作增加加载状态、错误提示和重复来源校验。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-30",
    title: "询盘与邮件加载提速",
    summary: "减少进入询盘工作台和邮件中心时的等待时间。",
    changes: [
      "询盘列表改为数据库分页读取，默认每页 50 条。",
      "邮件正文优先读取数据库缓存，缺失内容由后台异步补齐。",
      "增加邮件 UID 与 Message-ID 索引，降低重复检索开销。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-28",
    title: "新版询盘工作台",
    summary: "重组询盘、邮件、AI 分析、回复发送与历史跟进流程。",
    changes: [
      "上线高信息密度的三栏询盘工作台和可拖拽分栏。",
      "恢复 AI 背调公开来源，并支持从历史询盘跳转。",
      "工作台增加高价值客户与处理失败客户视图。",
      "隐藏 AI 内部思考过程，仅展示业务可用结论与依据。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-27",
    title: "AI 回复质量与安全加固",
    summary: "让首封回复更自然、简洁，并避免内部分析泄露给客户。",
    changes: [
      "首封回复采用低压力破冰结构，控制问题数量与回复门槛。",
      "增加回复草稿质量修复，拦截 AI 推理内容和内部背调信息。",
      "IMAP 同步增加超时恢复，减少轮询卡死和邮件漏单。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-24",
    title: "自动同步与移动端体验",
    summary: "新邮件能够持续进入 AI 队列，手机端也可完成核心询盘处理。",
    changes: [
      "修复 PostgreSQL 环境下新邮件未自动进入 AI 队列的问题。",
      "单个外部搜索来源失败时，AI 背调仍可继续完成。",
      "优化询盘中心移动端的列表、详情与返回操作。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-23",
    title: "数据与邮件存储升级",
    summary: "建立 PostgreSQL、Redis 与对象存储协同的数据基础。",
    changes: [
      "邮件和业务数据迁移到 PostgreSQL，队列与锁使用 Redis。",
      "邮件图片和附件迁移到对象存储，并支持历史图片回填。",
      "邮件中心同步时持久化正文，减少反复访问 IMAP。",
    ],
  },
  {
    version: "V1.1.5",
    date: "2026-07-21",
    title: "V1.1.5 基线版本",
    summary: "完善邮件、回复、签名、客户价值和跟进所需的基础能力。",
    changes: [
      "邮件中心支持定时同步、原始邮件查看、正文图片与附件展示。",
      "支持商业价值星级、日期筛选、收件人和抄送人编辑。",
      "AI 回复与签名分离编辑，并提供真实邮件格式的发送预览。",
      "增加持久化 AI 任务、失败重试和客户后续跟进状态。",
    ],
  },
];
